import { render } from "./Document.vue?vue&type=template&id=2538895e&ts=true&lang=html"
import script from "./Document.vue?vue&type=script&lang=ts"
export * from "./Document.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__